import Logo from '../logos/zieglersim';

export default Logo;
